import React from "react";
import about1 from "../../Assets/about1.jpg";
import about2 from "../../Assets/about2.jpg";
import about3 from "../../Assets/about3.jpg";
import "../../Template02/Combined.css";
import { Link } from "react-router-dom";
import { BsCheckSquare } from "react-icons/bs";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

function HomeScreen() {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section
        id="section-3592530"
        className="wb-heroHeader dark"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/5699522/pexels-photo-5699522.jpeg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="wb-heroHeader-wrapper">
          <div className="richTextWidget wb-heroHeader-content">
            <h2 style={{ marginBottom: "10px" }} className="main-heading">
              Medisol Labs
            </h2>
            <h6 style={{ textTransform: "capitalize" }}>
              We specialize in pharmaceutical research and formulation development
            </h6>
            <p style={{ }}>At Medisol, we are dedicated to advancing scientific discovery through cutting-edge research and formulation development. Our laboratory serves as a hub for innovation, driving solutions that meet the evolving needs of industries such as pharmaceuticals, biotechnology, cosmetics, and beyond.</p>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="section-3592533" className="widget-section">
        <div className="container boxWidget">
          <div className="row custom-row">
            <div className="col-lg-6">
              <div className="img-flex">
                <div className="imageWidget">
                  <img className=" img-top-left" src={about1} alt="" />
                </div>
                <div className="imageWidget">
                  <img className=" img-med" src={about2} alt="" />
                </div>
                <div className="imageWidget">
                  <img className=" img-down-left" src={about3} alt="" />
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="item-box">
                <div className="richTextWidget para-second para-normal">
                  
                  {/* <h4 className="heading-sub">ABOUT US</h4> */}
                  <h1
                    style={{ fontWeight: "700", textTransform: "capitalize" }}
                  >
                    Medisol Labs: Innovating Healthcare Solutions
                  </h1>
                  <p>
                    Medisol Labs is a leader in pharmaceutical research and
                    development. We specialize in creating high-quality
                    pharmaceutical products and medical devices that improve
                    patient outcomes. Our expert team focuses on drug
                    formulation and delivering innovative solutions to
                    healthcare providers globally.
                    <br /> We are committed to quality, safety, and compliance
                    in all our products, making us a trusted partner in the
                    healthcare industry.
                  </p>
                </div>
                <div className="richTextWidget">
                  <ul style={{ listStyle: "none" }}>
                    <li className="list-brands-item ">
                      <Link className="list-brands-link col-lg-2 col-sm-4 ">
                        <img
                          className="list-brands-img"
                          src="https://static.sitemantic.com/webbuilder/images/svg/icon10.svg"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li className="list-brands-item">
                      <Link className="list-brands-link col-lg-2 col-sm-4">
                        <img
                          className="list-brands-img"
                          src="https://static.sitemantic.com/webbuilder/images/svg/icon7.svg"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li className="list-brands-item">
                      <Link className="list-brands-link col-lg-2 col-sm-4">
                        <img
                          className="list-brands-img"
                          src="https://static.sitemantic.com/webbuilder/images/svg/icon9.svg"
                          alt=""
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Research and Formulation Development Section */}
      <section id="section-research-formulation" className="home-3rd">
        <div className="container boxWidget">
          <div className="row custom-row">
            <div className="col-lg-5">
              <div className="richTextWidget para-normal">
                <h1>Research and Formulation Development</h1>
                <p>
                  At Medisol Labs, we are committed to advancing healthcare
                  through groundbreaking pharmaceutical research and
                  cutting-edge formulation development. Our team of experienced
                  researchers and formulation scientists work together to
                  develop innovative products that meet the growing demands of
                  the healthcare industry.
                </p>
                <ul style={{ padding: "20px", marginBottom: "30px" }}>
                  <li
                    style={{
                      listStyle: "none",
                      fontWeight: "600",
                      marginTop: "10px",
                    }}
                  >
                    <BsCheckSquare /> Pharmaceutical Research
                  </li>
                  <li style={{ listStyle: "none", fontWeight: "300" }}>
                    We conduct in-depth research to create new drug formulations
                    and optimize existing treatments for better efficacy.
                  </li>
                  <li
                    style={{
                      listStyle: "none",
                      fontWeight: "600",
                      marginTop: "10px",
                    }}
                  >
                    <BsCheckSquare /> Innovative Formulation Development
                  </li>
                  <li style={{ listStyle: "none", fontWeight: "300" }}>
                    Our scientists work on developing formulations that are
                    safe, effective, and patient-friendly, addressing real-world
                    challenges.
                  </li>
                  <li
                    style={{
                      listStyle: "none",
                      fontWeight: "600",
                      marginTop: "10px",
                    }}
                  >
                    <BsCheckSquare /> Collaborative Partnerships
                  </li>
                  <li style={{ listStyle: "none", fontWeight: "300" }}>
                    We collaborate with leading pharmaceutical companies to
                    bring innovative solutions to market.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="item-box">
                <div className="imageWidget">
                  <img
                    className="lazyload sec-img"
                    src="https://images.pexels.com/photos/9742781/pexels-photo-9742781.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=1200&w=800"
                    alt="Research and Development"
                  />
                </div>
                <div className="imageWidget">
                  <img
                    className="lazyload sec-img2"
                    src="https://images.pexels.com/photos/9742749/pexels-photo-9742749.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=1200&w=800"
                    alt="Formulation Development"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </>
  );
}

export default HomeScreen;
